import PlanManagement from '../../../components/units/Management/Plan/PlanManagement';

export default function ProgixPlanPage() {
  return <PlanManagement />;
}
